module.exports = __webpack_public_path__ + "static/media/shopping-cart.95bc5ee0.svg";